import { MdWarning } from 'react-icons/md';

export type TrialErrorType = 'free_email' | 'competitor_email' | 'generic';

interface TrialErrorScreenProps {
  onBack: () => void;
  errorType?: TrialErrorType;
}

const ERROR_MESSAGES: Record<TrialErrorType, { description: string }> = {
  free_email: {
    description:
      'ご入力いただいたアドレス宛に、招待メールを送信することができませんでした。\n入力に誤りがあるか、Gmail等のフリーアドレスである可能性がございます。\n お手数ですが、所属されている組織・企業のメールアドレスにて再度ご入力をお願いいたします。',
  },
  competitor_email: {
    description:
      'ご入力いただいたメールアドレスではお申し込みいただけません。\n恐れ入りますが、別のメールアドレスにて再度お試しください。',
  },
  generic: {
    description:
      '申し込み処理中にエラーが発生しました。\n時間をおいて再度お試しいただくか、サポート窓口までお問い合わせください。',
  },
};

export default function TrialErrorScreen({ onBack, errorType = 'generic' }: TrialErrorScreenProps) {
  const { description } = ERROR_MESSAGES[errorType];

  return (
    <div className="relative min-h-screen overflow-hidden bg-white">
      {/* 背景装飾（右上の青いグラデーション楕円） */}
      <div
        className="pointer-events-none absolute top-0 right-0 hidden md:block"
        style={{
          width: '796.63px',
          height: '656.65px',
          background: '#A7DCFF',
          filter: 'blur(200px)',
          opacity: 0.3,
          transform: 'translate(30%, -20%)',
        }}
      />

      {/* 背景装飾（左上の青いグラデーション楕円 - SP版のみ） */}
      <div
        className="pointer-events-none absolute top-0 right-0 block md:hidden"
        style={{
          width: '400px',
          height: '400px',
          background: '#A7DCFF',
          filter: 'blur(100px)',
          opacity: 0.3,
          transform: 'translate(30%, -30%)',
        }}
      />

      {/* ヘッダー */}
      <header
        className="relative flex h-20 items-center bg-white px-8"
        style={{ boxShadow: '0px 0px 15px rgba(2, 98, 255, 0.2)' }}
      >
        <img src="/logo/agenthub.svg" alt="エージェントハブ" className="h-8" />
      </header>

      {/* メインコンテンツ */}
      <div className="relative mx-auto flex max-w-6xl flex-col items-center px-6 pt-[160px]">
        <div className="flex items-center justify-center gap-xxs md:gap-lg">
          <MdWarning size={60} className="size-xxl text-primary md:size-[60px]" />
          <h1 className="text-heading-md text-black md:text-heading-xl">
            申し込み完了できませんでした
          </h1>
        </div>

        {/* エラーメッセージ */}
        <p className="mt-[49px] mb-8 text-center text-[10px] leading-[170%] md:mt-xl md:w-[706px] md:text-body-md md:whitespace-pre-wrap">
          {description}
        </p>

        {/* サポート窓口情報 */}
        <div className="mb-[49px] flex flex-col items-center gap-3 rounded bg-gray px-xxl py-lg md:mb-[69px] md:w-[890px] md:px-x3l md:py-xl">
          <div className="flex flex-col items-center">
            <p className="text-center text-[10px] text-nowrap text-black md:text-body-sm">
              ご不明点やお困りのことがございましたら、以下のサポート
              <br className="md:hidden" />
              窓口までお気軽にお問い合わせください。
            </p>
            <p className="mt-md text-center text-[10px] text-black md:mt-0 md:text-body-sm">
              support@agenthub.jp (受付時間：平日10:00〜18:00)
            </p>
          </div>
        </div>

        {/* 申し込みに戻るボタン */}
        <button
          onClick={onBack}
          className="flex w-[264px] items-center justify-center gap-2 p-4 text-base leading-normal font-bold text-white transition-opacity hover:opacity-90 md:w-[350px]"
          style={{ backgroundColor: '#005FFF', borderRadius: '100px' }}
        >
          申し込みに戻る
        </button>
      </div>
    </div>
  );
}
